import { Room } from "@domain";
import { SyncInteractor } from "@kernel/frontend-react-app";

export interface DisableRemoteTransceiverInteractorProps {
  room: Room;
  type: "audio" | "video";
}

export class DisableRemoteTransceiverInteractor extends SyncInteractor<
  DisableRemoteTransceiverInteractorProps,
  void
> {
  public execute(props: DisableRemoteTransceiverInteractorProps): void {
    const stream = props.room.localParticipant?.stream || null;
    if (!stream) return;
    const remoteParticipants = props.room.remoteParticipants;
    for (const participant of remoteParticipants.getItems()) {
      participant.disableTransceiver(props.type, stream);
    }
  }

  public static create(): DisableRemoteTransceiverInteractor {
    return new DisableRemoteTransceiverInteractor();
  }
}
